export default __webpack_public_path__ + "static/media/InfoUtilsCard.bd5220bf.svg";